import type {
  ChangePasswordInput,
  IAuthRepository,
} from '@/features/authentication/domain/repositories/IAuthRepository.js';

export function createChangePasswordUseCase(deps: { authRepository: IAuthRepository }) {
  return (input: ChangePasswordInput): Promise<void> =>
    deps.authRepository.changePassword(input);
}
